module.exports = __webpack_public_path__ + "static/14th-1d97f3b0e07a847c790153931d8e1169.png";